export default "__VITE_ASSET__CcSQGbgu__"